import { FC, useMemo } from 'react';
import { FormControl, FormLabel, Input, Stack, useToast, Grid, GridItem } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'lib/redux';
import { selectMe, updateMe, DeleteAccount, UndoDeleteAccount } from 'domains/account';
import { pick } from 'lodash';
import { Formik, Form, Field, FieldProps } from 'formik';
import { ButtonSubmit } from 'components';
import { EditProfileFields } from './types';
import { editProfileSchema } from './editProfileSchema';
import { useBreakpointValue } from '@chakra-ui/media-query';

export const EditProfileForm: FC = () => {
  const { user } = useAppSelector(selectMe);
  const isFullWidth = useBreakpointValue([ true, false ]);
  const dispatch = useAppDispatch();
  const toast = useToast();

  const initialValues = useMemo(
    () => pick(
      user, [
        EditProfileFields.first_name,
        EditProfileFields.last_name,
        EditProfileFields.email
      ]
    ), [user]
  );

  const onSubmit = async (values: any) => {
    try {
      const u = { ...values };

      await dispatch(updateMe(u));
      toast({
        title: 'Profile updated',
        status: 'success',
        position: 'top-right',
        duration: 3000,
      });
    } catch (err) {
      console.error(err)
    }
  };

  return (
    <Formik enableReinitialize onSubmit={onSubmit} initialValues={initialValues}>
      <Form>
        <Stack spacing={6} className="form__stack">
          {editProfileSchema.map((s) => (
            <Field key={s.name} name={s.name} className="form-field__wrapper">
              {({ field, form, meta }: FieldProps) => (
                <FormControl
                  isInvalid={Boolean(meta.touched && form.errors[field.name])}
                  isRequired={s?.isRequired || false}
                  isDisabled={s?.isDisabled || false}
                  className="form-field__control"
                >
                  <FormLabel className="form-profile__label">{s.label}</FormLabel>
                  <Input {...field} type={s?.type || 'text'} />
                </FormControl>
              )}
            </Field>
          ))}
          <Grid gridTemplateColumns={['1fr', "auto auto"]} gap="20px" justifyContent="space-between">
            <GridItem>
              <ButtonSubmit isFullWidth={isFullWidth}>Update Profile</ButtonSubmit>
            </GridItem>
            <GridItem>
              <DeleteAccount />
              <UndoDeleteAccount />
            </GridItem>
          </Grid>
        </Stack>
      </Form>
    </Formik>
  )
};